var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
export var Icon = function (_a) {
    var style = _a.style, className = _a.className, icon = _a.icon, color = _a.color, size = _a.size, spin = _a.spin, rest = __rest(_a, ["style", "className", "icon", "color", "size", "spin"]);
    return (React.createElement(FontAwesomeIcon, __assign({ style: style, className: className, icon: icon, color: color, size: size, spin: spin }, rest)));
};
